<template>
  <div v-if="requests.any()">
    <v-icon @click="showRequests = true">mdi-format-list-checkbox</v-icon>

    <HvhModal title="All Requests" maxWidth="90vw" :value="true" @input="showRequests = false" v-if="showRequests">
      <DataTable :data="requests">
        <template #head>
          <tr>
            <Th prop="createdBy.email" sort>Requester</Th>
            <Th prop="reviewedBy?.email" sort>Manager</Th>
            <Th prop="value" v-if="hasValue">Requested Value</Th>
            <Th prop="reviewedAt" sort>Review Date</Th>
            <Th prop="reason" sort>Reason</Th>
            <Th prop="reviewReason" sort>Approve/Deny Reason</Th>
            <Th prop="isApproved" sort>Approved</Th>
          </tr>
        </template>
        <template #body="{ item }">
          <tr>
            <td>{{ item.createdBy.email || '-' }}</td>
            <td>{{ item.reviewedBy?.email || '-' }}</td>
            <td v-if="hasValue">{{ item.value }}</td>
            <td>{{ dateFormat(item.reviewedAt) || '-' }}</td>
            <td>{{ item.reason || '-' }}</td>
            <td>{{ item.reviewReason || '-' }}</td>
            <td>
              <div v-if="item.isApprovalRequested && item.reviewedBy">
                <v-icon title="Approved" v-if="item.isApproved">mdi-check</v-icon>
                <v-icon title="Denied" v-else>mdi-close</v-icon>
              </div>
              <div v-else>
                <div v-if="item.isApprovalRequested">Waiting Approval</div>
                <div v-else>Not Requested</div>
              </div>
            </td>
          </tr>
        </template>
      </DataTable>
    </HvhModal>
  </div>
</template>

<script>
import DataTable from '../common/dataTable/DataTable.vue';
import Th from '../common/dataTable/Th.vue';
import HvhModal from '../common/modal/HvhModal.vue';
export default {
  components: { HvhModal, DataTable, Th },
  props: ['value', 'type'],
  data() {
    return {
      showRequests: false,
    };
  },
  computed: {
    requests() {
      return this.value.requests
        .filter(f => f.type === this.type)
        .sortBy(f => f.reviewedAt)
        .reverse();
    },
    hasValue() {
      return this.requests.first()?.value;
    }
  },
}
</script>